var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 66,
    viewBox: "0 0 82 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1211_7796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M77.3313 20.8913L76.9122 22.6028L62.1761 19.2463L62.5428 17.6284L62.5774 17.6381L62.8254 16.3961L61.6597 14.3224L61.2349 16.0342L53.5067 14.2765L53.4189 12.4527C54.3856 11.8139 55.1182 10.8105 55.396 9.59549C55.975 7.06189 54.3891 4.54712 51.8593 3.97417C50.5972 3.68756 49.3381 3.93612 48.3146 4.57767C47.2967 5.21895 46.5251 6.24131 46.233 7.51393C45.9555 8.73459 46.1795 9.95389 46.7744 10.9446L45.9054 12.5468L36.5867 10.4272L35.9374 13.2774L20.5733 9.78033L5.08479 77.6794L3.52347 77.3332L4.6892 79.4069L62.6076 92.5975L78.4971 22.965L77.3313 20.8913ZM52.8662 9.02255C52.767 9.44874 52.5508 9.81223 52.256 10.0827C51.7593 10.5394 51.063 10.7552 50.3542 10.5957C49.6511 10.4359 49.1142 9.93785 48.8674 9.31192C48.7183 8.93755 48.681 8.51793 48.7745 8.09201C49.0336 6.96335 50.1622 6.25409 51.2859 6.5075C52.4155 6.76632 53.1253 7.89388 52.8662 9.02255Z",
    fill: "#DD9C00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.327 20.8922L19.4106 7.70197L3.5194 77.3318L61.4357 90.522L77.327 20.8922Z",
    fill: "#FFD266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M70.7778 24.3364L23.8186 13.6416L10.0702 73.8821L57.0294 84.5768L70.7778 24.3364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.502 15.5492L52.253 10.3789C53.2197 9.74013 53.9523 8.73673 54.2301 7.52175C54.8091 4.98815 53.2232 2.47338 50.6934 1.90043C49.4313 1.61382 48.1722 1.86238 47.1487 2.50393C46.1308 3.14521 45.3592 4.16757 45.0671 5.44019C44.7896 6.66085 45.0136 7.88014 45.6085 8.87087L43.1432 13.4258L52.4966 15.5552L52.502 15.5492ZM50.114 4.42835C51.2437 4.68717 51.9534 5.81473 51.6943 6.9434C51.5951 7.36959 51.3789 7.73308 51.0842 8.00354C50.5875 8.46026 49.8911 8.67603 49.1823 8.51654C48.4793 8.35677 47.9423 7.8587 47.6956 7.23277C47.5464 6.85839 47.5091 6.43878 47.6026 6.01286C47.8618 4.88419 48.9904 4.17494 50.114 4.42835Z",
    fill: "#FFB400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.6566 14.3216L35.4238 8.34717L33.1367 18.3688L59.3694 24.3432L61.6566 14.3216Z",
    fill: "#FFB400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.3862 27.9851L25.6707 26.228L23.9113 33.9369L31.6268 35.6941L33.3862 27.9851Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.4989 29.0928L31.6884 30.8569L31.1959 31.1653L31.0189 31.2764L27.8875 33.2438L25.5544 29.5349L27.4632 28.3382L28.5988 30.1401L31.7301 28.1726L32.3939 27.7534L33.3013 27.1858L34.4989 29.0928Z",
    fill: "#1E69D2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M30.2924 41.5484L22.5769 39.7913L20.8175 47.5002L28.5331 49.2574L30.2924 41.5484Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.4074 42.6587L28.5911 44.423L28.0987 44.7315L27.9273 44.8422L24.7903 46.8099L22.4629 43.1008L24.3714 41.8984L25.5012 43.7005L28.6329 41.7388L29.3024 41.3193L30.2098 40.7517L31.4074 42.6587Z",
    fill: "#1E69D2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.1945 55.1106L19.479 53.3535L17.7196 61.0624L25.4352 62.8195L27.1945 55.1106Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.7146 31.8801L61.231 36.5528",
    stroke: "#B3B5BE",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M39.9241 35.3464L54.4237 38.646",
    stroke: "#B3B5BE",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M37.6233 45.446L58.1337 50.1133",
    stroke: "#B3B5BE",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M36.8325 48.9123L51.3265 52.2121",
    stroke: "#B3B5BE",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.5259 59.0121L55.0363 63.6794",
    stroke: "#B3B5BE",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M33.7351 62.4728L48.235 65.778",
    stroke: "#B3B5BE",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1211_7796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.5019,
    height: 91.3415,
    fill: "white",
    transform: "translate(0 4.16504) rotate(-2.75693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer_1.24ed8d4bef63cdfc24fad3ff9c123db4.svg";
export { ForwardRef as ReactComponent };